import { jsxs, jsx, Fragment } from 'react/jsx-runtime';
import { useRef, useState, useEffect } from 'react';
import classNames from 'classnames';
import { ChevronDownIcon } from '@cognite/cogs-icons';
import { useWidth } from '@cognite/cogs-utils';
import { Tooltip } from '../tooltip/tooltip.js';

var AccordionHeader = function AccordionHeader(_ref) {
  var disabled = _ref.disabled,
    expand = _ref.expand,
    title = _ref.title,
    subtitle = _ref.subtitle,
    expanded = _ref.expanded,
    indicatorPlacement = _ref.indicatorPlacement;
  var subtitleRef = useRef(null);
  var _useState = useState(false),
    subtitleOverflowed = _useState[0],
    setSubtitleOverflowed = _useState[1];
  var subtitleWidth = useWidth(subtitleRef);
  useEffect(function () {
    var subtitlePlaceholder = subtitleRef.current;
    var pElement = subtitlePlaceholder === null || subtitlePlaceholder === undefined ? undefined : subtitlePlaceholder.getElementsByTagName('p')[0];
    if (pElement && pElement.scrollWidth > (subtitlePlaceholder === null || subtitlePlaceholder === undefined ? undefined : subtitlePlaceholder.clientWidth)) {
      setSubtitleOverflowed(true);
    } else {
      setSubtitleOverflowed(false);
    }
  }, [subtitleWidth]);
  var renderRightIndicator = function renderRightIndicator() {
    if (indicatorPlacement === 'left') return null;
    return jsx(ChevronDownIcon, {
      className: "cogs-v10 cogs-accordion__header__icon " + (expanded ? 'cogs-v10 cogs-accordion__header__icon--expanded' : '')
    });
  };
  var renderLeftIndicator = function renderLeftIndicator() {
    if (indicatorPlacement === 'right') return null;
    return jsx(ChevronDownIcon, {
      className: "cogs-v10 cogs-accordion__header__icon " + (expanded ? 'cogs-v10 cogs-accordion__header__icon--expanded' : '')
    });
  };
  var handleExpand = function handleExpand() {
    if (!disabled) {
      expand === null || expand === undefined ? undefined : expand();
    }
  };
  var handleKeyPress = function handleKeyPress(e) {
    if (e.key === 'Enter' || e.key === ' ') {
      handleExpand();
    }
  };
  return jsxs("div", {
    className: classNames('cogs-v10', 'cogs-accordion__header', indicatorPlacement && "cogs-accordion__header--" + indicatorPlacement),
    "aria-disabled": disabled,
    onClick: handleExpand,
    role: "button",
    onKeyPress: handleKeyPress,
    tabIndex: 0,
    children: [renderLeftIndicator(), jsxs("div", {
      className: "cogs-v10 cogs-accordion__header__title",
      children: [jsx("div", {
        ref: subtitleRef,
        className: "cogs-v10 cogs-accordion__header__title--subtitle--placeholder",
        children: jsx("p", {
          children: subtitle
        })
      }), jsx(Tooltip, {
        content: subtitle,
        disabled: !subtitleOverflowed || typeof subtitle !== 'string',
        placement: "top",
        interactive: false,
        children: jsxs(Fragment, {
          children: [jsx("p", {
            children: title
          }), subtitle && jsx("p", {
            className: "subtitle",
            children: subtitle
          })]
        })
      })]
    }), renderRightIndicator()]
  });
};

export { AccordionHeader as default };
